// Componente principal do Login - agora usa o container para gerenciar estado
import * as React from 'react';
import LoginContainer from './LoginContainer';

const Login: React.FC = () => {
  return <LoginContainer />;
};

export default Login;
